export default __webpack_public_path__ + "static/hotspotty-5022fa4da6ddeea2130fef3b3a051dba.svg";